






























import { Module } from '@/models/configurator/module';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'ModuleImage',

  props: {
    module: { type: Object as PropType<Module>, required: true }
  },

  data() {
    return {
      blobURL: null as string | null,
      loading: false,
      isVisible: false,

      errorMessage: '',
      detailErrorMessage: ''
    };
  },

  watch: {
    isVisible(value: boolean) {
      if (value) {
        this.loadImage();
      }
    },

    'module.image'() {
      // if we were to update image then revoke object url to avoid mem-leak then reload
      this.imageLoaded();
      this.loadImage();
    }
  },

  methods: {
    /**
     * Once the image is loaded, revoke the object url (avoid memory leak).
     * Notice that the page can still show the image, but the src blob is no longer valid.
     */
    imageLoaded() {
      if (this.blobURL) URL.revokeObjectURL(this.blobURL);
    },
    loadImage() {
      if (!this.module.image_url) {
        this.imageLoaded();
        this.blobURL = null;
        return;
      }
      this.loading = true;
      this.$services.fileLoader
        .downloadFile(this.module.image_url as string)
        .then(data => {
          this.blobURL = URL.createObjectURL(data);
        })
        // Not to display error
        .catch(error => {})
        .finally(() => {
          this.loading = false;
        });
    }
  }
});
